import { useTileRenderer } from './TileRenderer.jsx'

// Accepts EITHER a `code` string plus props:
//   <Tile code="5m" width={34} highlight rotated highlightColor />
// OR a single canonical `tile` object:
//   <Tile tile={{ code: '5m', highlight: true }} width={34} />
export default function Tile(props) {
  const renderTile = useTileRenderer()
  const { tile } = props
  const code = tile ? tile.code : props.code
  const highlight = tile && tile.highlight !== undefined ? tile.highlight : props.highlight
  const rotated = tile && tile.rotated !== undefined ? tile.rotated : props.rotated
  const width = props.width ?? 34
  const { highlightColor } = props

  const node = renderTile({
    code,
    width,
    highlight: !!highlight,
    rotated: !!rotated,
    highlightColor,
  })

  return props.className
    ? <span className={props.className}>{node}</span>
    : node
}
